import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "users-main-body",
			d: "M1.33334 13.3333C2.631 11.6817 4.3928 10.6667 6.33334 10.6667C8.27389 10.6667 10.0357 11.6817 11.3333 13.3333",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "users-main-head",
			d: "M9.33334 5C9.33334 6.65685 7.9902 8 6.33334 8C4.67649 8 3.33334 6.65685 3.33334 5C3.33334 3.34315 4.67649 2 6.33334 2C7.9902 2 9.33334 3.34315 9.33334 5Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "users-secondary-head",
			d: "M10.6667 2.31184C11.6545 2.80274 12.3333 3.82209 12.3333 5C12.3333 6.17791 11.6545 7.19726 10.6667 7.68816",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "users-secondary-body",
			d: "M12 11.1776C13.0076 11.6336 13.915 12.3767 14.6667 13.3333",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUsers;
